// src/utils/recorridoRuta.js
//
// Helpers puros para "Rutas del día" (card #414): mensajes de error del
// contrato Optimizar/Recorrido (POST .../optimizar, GET .../recorrido) y
// formateo de hora de llegada/distancia/duración. Sin dependencias de
// Vue/Vuex a propósito — se usan tanto desde la store (mapear errores del
// backend) como directo desde los componentes de la vista (panel de paradas,
// tarjeta flotante del mapa).

/**
 * Mensajes en español para cada código de error del contrato Optimizar/
 * Recorrido (ver rutasRepartoService.optimizarRuta/obtenerRecorrido).
 */
export const MENSAJES_ERROR_RECORRIDO = {
  SIN_CENTRO: 'Configurá un centro de distribución en la pestaña Configuración',
  SIN_PARADAS: 'La ruta no tiene paradas para optimizar',
  DEMASIADAS_PARADAS: 'La ruta tiene demasiadas paradas para optimizar',
  RUTA_NO_ENCONTRADA: 'No se encontró la ruta',
  RUTA_NO_EDITABLE: 'La ruta ya no se puede editar',
  GOOGLE_NO_CONFIGURADO: 'El optimizador de rutas no está configurado',
  GOOGLE_ERROR: 'Error al calcular el recorrido óptimo',
};

export function mensajeErrorRecorrido(code, mensajePorDefecto = 'Error al procesar el recorrido') {
  return MENSAJES_ERROR_RECORRIDO[code] || mensajePorDefecto;
}

/**
 * "llega hh:mm" = `ahora` (hora local, solo tiene sentido cuando la ruta está
 * `armada`) + `llegadaSegundos` — ver EditorRutaDialog/panel de paradas.
 */
export function formatearLlegada(ahora, llegadaSegundos) {
  if (llegadaSegundos == null) return null;
  const fecha = new Date(ahora.getTime() + llegadaSegundos * 1000);
  const horas = String(fecha.getHours()).padStart(2, '0');
  const minutos = String(fecha.getMinutes()).padStart(2, '0');
  return `${horas}:${minutos}`;
}

/** Metros -> "X.Y km" (1 decimal). */
export function formatearDistanciaKm(metros) {
  if (metros == null) return null;
  return `${(metros / 1000).toFixed(1)} km`;
}

/** Segundos -> "1 h 25 min" / "45 min" / "2 h". */
export function formatearDuracion(segundos) {
  if (segundos == null) return null;
  const totalMinutos = Math.round(segundos / 60);
  const horas = Math.floor(totalMinutos / 60);
  const minutos = totalMinutos % 60;
  if (horas <= 0) return `${minutos} min`;
  if (minutos === 0) return `${horas} h`;
  return `${horas} h ${minutos} min`;
}
